// extracted by mini-css-extract-plugin
module.exports = {"defaultButton":"style-module__defaultButton___2aMnS"};